import { createReducer } from "redux-act";
import createAction from "./utils/createMetaAction";
export const toggleCopyOption = createAction("TOGGLE_COPY_OPTION");
export const defaultCopyOptions = {
  features: true,
  partialFeatures: false,
  parts: true,
  partialParts: false
};
export default createReducer(
  {
    [toggleCopyOption]: (state, type) => {
      return {
        ...state,
        ...type === "partialFeatures" && !state[type] && { features: true },
        ...type === "partialParts" && !state[type] && { parts: true },
        ...type === "features" && { partialFeatures: !state[type] },
        ...type === "parts" && { partialParts: !state[type] },
        [type]: !state[type]
      };
    }
  },
  defaultCopyOptions
);
